/**
 * The proposal questions' option lists and fuel rule, kept INSIDE this package.
 *
 * This package imports @officehub/shared for TYPES only (erased at build): the tech PWA and the main
 * client's jest cannot resolve shared from this package's dist (see permitRules.ts, measured on #7539).
 * The server (survey_updateSection) stays the authority; src/__tests__/proposalRules.parity.test.ts
 * fails if anything here drifts from shared/src/types/survey.ts and shared/src/lib/survey/proposalSection.ts.
 */
import type { SurveyFuel } from '@officehub/shared';

/** Same cap the server applies to every proposal text answer. */
export const MAX_PROPOSAL_TEXT_LENGTH = 2000;

export const SURVEY_FUELS = ['natural_gas', 'propane', 'diesel'] as const;
export const SYSTEM_CHANGES = ['keep', 'replace', 'new'] as const;
export const PROPANE_TANK_STATUSES = ['existing', 'new'] as const;
export const DIESEL_TANK_KINDS = ['sub_base', 'above_ground', 'underground'] as const;

/** The fuel a survey is for: a missing or unknown choice reads as natural gas (every older survey). */
export function effectiveProposedFuel(stored: string | null | undefined): SurveyFuel {
  return stored && (SURVEY_FUELS as readonly string[]).includes(stored) ? (stored as SurveyFuel) : 'natural_gas';
}

export interface FuelQuestions {
  gasMeter: boolean;
  propaneTank: boolean;
  dieselTank: boolean;
}

/** Which fuel-specific questions apply to the CURRENT fuel. */
export function proposalFieldsForFuel(fuel: SurveyFuel): FuelQuestions {
  return { gasMeter: fuel === 'natural_gas', propaneTank: fuel === 'propane', dieselTank: fuel === 'diesel' };
}
